/* Fabareeze conversion callout. Cart drawer: always-on BANK TRANSFER TOTAL line + COD reassurance. PDP #fbQtyNudge shows the cart total by bank transfer ONLY when the cart has items; with an empty cart the whole block is hidden (2026-09-16 mobile PDP pass: its old default copy repeated the tick row and the Save-4% box word for word — three bank-transfer mentions in one screen). Observer watches the stable <cart-drawer> wrapper so it survives Dawn's drawer re-renders.
   2026-08-06: PDP copy split from drawer copy. On a PRODUCT page the bare 'Bank transfer total — Rs X' printed the CART total, which read as a wrong price for the product on screen (owner caught Rs 6,600 under a Rs 7,250 suit). The PDP now says 'Your cart by bank transfer' + the item count; the DRAWER keeps the short label because inside the cart the context is obvious. This JS is the copy of record for #fbQtyNudge — it overwrites the Liquid-rendered branch in fb-pdp-trust.liquid on every cart change, so keep the two in sync.
   2026-09-03: 'pieces' -> 'items' in the PDP bank line. On a 3-piece suit PDP, 'the 2 pieces already in your cart' read as the SUIT being 2 pc (owner caught it on the shawl set). 'items' can never collide with the suit's piece count.
   2026-09-05 FLAT CAMPAIGN: the Rs-400 second-suit offer and the Rs-35k gift are OFF (owner's call) — qtyMsg deleted. OWNER RULE 2026-09-05: never PUSH COD (fake orders + refusals); the drawer adds an honest 'carts don't reserve stock' line under the bank-transfer total because cart->checkout (46%) is the funnel's biggest leak; bankMsg prints the Rs COD-vs-transfer comparison (a number beats 'skip the tax'), and Dawn's 'Taxes ... calculated at checkout' note — which reads as hidden costs in a COD market — is rewritten to 'no hidden charges'. Owner must also deactivate the two automatic discounts in admin at launch. */
(function(){
  function money(paise){ return 'Rs '+Math.round(paise/100).toLocaleString('en-PK'); }
  function bankMsgPdp(c){
    if(c.total_price<=0) return null;
    return {lead:'Your cart by bank transfer — '+money(c.total_price), sub:'Total for the '+c.item_count+(c.item_count===1?' item':' items')+' already in your cart — bank transfer skips the 4% COD tax.'};
  }
  function bankMsg(c){
    if(c.total_price<=0) return null;
    var cod=Math.round(c.total_price*1.04);
    return {lead:'Bank transfer — '+money(c.total_price)+' · COD — '+money(cod), sub:'Save '+money(cod-c.total_price)+' — no 4% govt COD tax. Account details at checkout.'};
  }
  function holdMsg(){
    return {lead:"Sale stock isn't reserved in carts", sub:"It's yours once you check out — once sold, never restocked."};
  }
  function setPdp(el, m){
    var box=el.closest('.fb-conv--nudge')||el;
    if(!m){ box.style.display='none'; el.setAttribute('data-m',''); return; }
    box.style.display='';
    var key=m.lead+'|'+m.sub;
    if(el.getAttribute('data-m')===key) return;
    el.setAttribute('data-m', key);
    el.innerHTML='';
    var a=document.createElement('span'); a.className='fb-conv__lead'; a.textContent=m.lead;
    var b=document.createElement('span'); b.className='fb-conv__sub'; b.textContent=m.sub;
    el.appendChild(a); el.appendChild(b);
  }
  function setCart(n, parts){
    var key=parts.map(function(p){return p.lead;}).join('|');
    if(n.getAttribute('data-m')===key) return;
    n.setAttribute('data-m', key);
    n.innerHTML='';
    parts.forEach(function(p){
      var b=document.createElement('span'); b.className='fb-cnudge__b';
      var a=document.createElement('span'); a.className='fb-cnudge__lead'; a.textContent=p.lead;
      var s=document.createElement('span'); s.className='fb-cnudge__sub'; s.textContent=p.sub;
      b.appendChild(a); b.appendChild(s); n.appendChild(b);
    });
  }
  var busy=false, pending=false;
  function refresh(){
    if(busy){ pending=true; return; }
    busy=true; pending=false;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      busy=false;
      var q=c.item_count;
      var p=document.getElementById('fbQtyNudge');
      if(p){ setPdp(p, bankMsgPdp(c)); }
      var f=document.querySelector('#CartDrawer .drawer__footer')||document.getElementById('main-cart-footer');
      if(f){
        var n=f.querySelector('.fb-cnudge');
        if(q<=0){ if(n){n.remove();} }
        else {
          var parts=[]; var bm=bankMsg(c); if(bm){parts.push(bm);parts.push(holdMsg());}
          if(!parts.length){ if(n){n.remove();} }
          else { if(!n){ n=document.createElement('div'); n.className='fb-cnudge'; f.insertBefore(n, f.firstChild); } setCart(n, parts); }
        }
      }
      var tns=document.querySelectorAll('#CartDrawer .tax-note, .cart__footer .tax-note, cart-drawer .tax-note');
      for(var ti=0;ti<tns.length;ti++){ tns[ti].textContent='Free delivery — no hidden charges. Bank transfer at checkout skips the 4% COD tax.'; }
      if(pending) refresh();
    }).catch(function(){ busy=false; if(pending) refresh(); });
  }
  var t=null; function sched(){ clearTimeout(t); t=setTimeout(refresh,160); }
  function start(){
    var roots=[document.querySelector('cart-drawer'), document.getElementById('CartDrawer'), document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')].filter(Boolean);
    roots.forEach(function(rt){ try{ new MutationObserver(sched).observe(rt,{childList:true,subtree:true}); }catch(e){} });
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate){ try{ subscribe(PUB_SUB_EVENTS.cartUpdate, sched); }catch(e){} }
    document.addEventListener('cart:refresh', sched);
    sched();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
